import React from "react";
import ReactDOM from "react-dom";
import AppContainer from "./containers/AppContainer";
import SnackbarProvider from 'react-simple-snackbar'



ReactDOM.render(<SnackbarProvider><AppContainer /></SnackbarProvider>
, document.getElementById("root"));
